import { InjectionToken } from '@angular/core';

export const CONFIGURATIONS_PROVIDER_KEY = 'ConfigurationsProvider';
export const CONFIGURATIONS_PROVIDER_TOKEN = new InjectionToken(
  CONFIGURATIONS_PROVIDER_KEY,
);

export const COMMERCIAL_LIST_PROVIDER_KEY = 'CommercialListProviderService';
export const COMMERCIAL_LIST_PROVIDER_TOKEN = new InjectionToken(
  COMMERCIAL_LIST_PROVIDER_KEY,
);

export const HTTP_PROVIDER_KEY = 'HttpProvider';
export const HTTP_PROVIDER_TOKEN = new InjectionToken(HTTP_PROVIDER_KEY);

export const HTTP_BODY_PROVIDER_KEY = 'HttpBodyProvider';
export const HTTP_BODY_PROVIDER_TOKEN = new InjectionToken(
  HTTP_BODY_PROVIDER_KEY,
);

export const HTTP_ORDER_FILTERS_KEY = 'HttpOrderFilters';
export const HTTP_ORDER_FILTERS_TOKEN = new InjectionToken(
  HTTP_ORDER_FILTERS_KEY,
);

export const HTTP_ORDER_KEY = 'HttpOrderService';
export const HTTP_ORDER_TOKEN = new InjectionToken(HTTP_ORDER_KEY);

export const LIST_ACCESS_PROVIDER_KEY = 'ListAccessProvider';
export const LIST_ACCESS_PROVIDER_TOKEN = new InjectionToken(
  LIST_ACCESS_PROVIDER_KEY,
);

export const LIST_WITH_PRODUCT_SEARCH_PROVIDER_KEY =
  'ListWithProductSearchProvider';
export const LIST_WITH_PRODUCT_SEARCH_PROVIDER_TOKEN = new InjectionToken(
  LIST_WITH_PRODUCT_SEARCH_PROVIDER_KEY,
);

export const OPENED_LIST_DATA_PROVIDER_KEY = 'OpenedListDataProvider';
export const OPENED_LIST_DATA_PROVIDER_TOKEN = new InjectionToken(
  OPENED_LIST_DATA_PROVIDER_KEY,
);

export const OPENED_LIST_ENTITY_PROVIDER_KEY =
  'OpenedListEntityProviderService';
export const OPENED_LIST_ENTITY_PROVIDER_TOKEN = new InjectionToken(
  OPENED_LIST_ENTITY_PROVIDER_KEY,
);

export const PRODUCT_BASKET_PROVIDER_KEY = 'ProductBasketProvider';
export const PRODUCT_BASKET_PROVIDER_TOKEN = new InjectionToken(
  PRODUCT_BASKET_PROVIDER_KEY,
);

export const PRODUCT_FILTERS_PROVIDER_KEY = 'ProductFiltersProvider';
export const PRODUCT_FILTERS_PROVIDER_TOKEN = new InjectionToken(
  PRODUCT_FILTERS_PROVIDER_KEY,
);

export const PRODUCT_PROVIDER_KEY = 'ProductProviderService';
export const PRODUCT_PROVIDER_TOKEN = new InjectionToken(PRODUCT_PROVIDER_KEY);

export const GLOBAL_STORE_PROVIDER_KEY = 'GlobalStoreProviderService';
export const GLOBAL_STORE_PROVIDER_TOKEN = new InjectionToken(
  GLOBAL_STORE_PROVIDER_KEY,
);

// General token, can be used for all dynamic components
// Common usage: Provide any AbstractDataProvider in parent component
export const DYNAMIC_DATA_PROVIDER_KEY = 'DynamicDataProviderKey';
export const DYNAMIC_DATA_PROVIDER_TOKEN = new InjectionToken(
  DYNAMIC_DATA_PROVIDER_KEY,
);

export const UTILITIES_PROVIDER_KEY = 'UtilitiesProviderService';
export const UTILITIES_PROVIDER_TOKEN = new InjectionToken(
  UTILITIES_PROVIDER_KEY,
);
